import { eventChannel, EventChannel } from 'redux-saga'

export function createVisibilityChannel(): EventChannel<boolean> {
  return eventChannel<boolean>((emitter) => {
    const changeHandler = () => {
      if (document.visibilityState === 'visible') {
        emitter(true)
      }
    }

    document.addEventListener('visibilitychange', changeHandler)

    // Cleanup function
    return () => {
      document.removeEventListener('visibilitychange', changeHandler)
    }
  })
}
